import { motion } from "motion/react";
import { t } from "@/lib/i18n";
import type { TimelineSection as TimelineData } from "@/data/profile";
import type { SectionProps } from "../types";
import { SectionFrame } from "../SectionFrame";

export function TimelineSection({ section, number, ctx }: SectionProps<TimelineData>) {
  const { lang, presets } = ctx;

  return (
    <SectionFrame number={number} kicker={section.kicker} title={section.title} ctx={ctx}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}>
        {section.items.map((item, i) => (
          <motion.div
            key={`${t(item.title, lang)}-${i}`}
            variants={presets.pop(0.14 + i * 0.07)}
            style={{
              padding: "11px 15px",
              background: "var(--tc-paper)",
              borderLeft: "2px solid var(--tc-brass)",
              borderRadius: "0 5px 5px 0",
            }}
          >
            <div
              style={{
                fontFamily: "var(--tc-mono)",
                fontSize: 10,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "var(--tc-brass)",
                marginBottom: 2,
              }}
            >
              {t(item.year, lang)}
            </div>
            <div style={{ fontFamily: "var(--tc-serif)", fontSize: 18, color: "var(--tc-ink-strong)", lineHeight: 1.15 }}>
              {t(item.title, lang)}
            </div>
            <div style={{ fontSize: 14, lineHeight: 1.4, color: "var(--tc-muted)", marginTop: 2 }}>
              {t(item.desc, lang)}
            </div>
          </motion.div>
        ))}
      </div>
    </SectionFrame>
  );
}
